import { useEffect } from "react";

/**
 * Global "tekan Enter = Simpan".
 * - Di dalam Dialog: klik tombol [data-enter-submit] bila ada, jika tidak tombol terakhir di DialogFooter (Simpan).
 * - Di dalam [data-enter-scope]: klik tombol [data-enter-submit] di scope tsb.
 * - Di halaman biasa: klik satu-satunya tombol [data-enter-submit] yang berada di luar scope/dialog.
 * Diabaikan untuk textarea, checkbox/radio/file, elemen di dalam <form> (sudah submit native),
 * elemen [data-enter-ignore], kombinasi Shift/Ctrl/Alt, dan saat IME composing.
 */
const SKIP_TYPES = new Set(["checkbox", "radio", "button", "submit", "reset", "file", "range", "color"]);

const usable = (b) => b && !b.disabled && b.getAttribute("aria-disabled") !== "true" && b.offsetParent !== null;

function findTarget(el) {
  const dialog = el.closest('[role="dialog"], [role="alertdialog"]');
  const scope = el.closest("[data-enter-scope]");
  if (scope && (!dialog || dialog.contains(scope))) {
    const b = scope.querySelector("[data-enter-submit]");
    return usable(b) ? b : null;
  }
  if (dialog) {
    const explicit = dialog.querySelector("[data-enter-submit]");
    if (explicit) return usable(explicit) ? explicit : null;
    const footer = dialog.querySelector("[data-dialog-footer]");
    if (!footer) return null;
    const btns = Array.from(footer.querySelectorAll("button")).filter((b) => !b.hasAttribute("data-enter-skip"));
    const last = btns[btns.length - 1];
    if (!last) return null;
    const txt = (last.textContent || "").trim().toLowerCase();
    if (["batal", "tutup", "cancel", "close"].includes(txt)) return null;
    return usable(last) ? last : null;
  }
  const candidates = Array.from(document.querySelectorAll("[data-enter-submit]")).filter(
    (b) => !b.closest("[data-enter-scope]") && !b.closest('[role="dialog"], [role="alertdialog"]')
  );
  if (candidates.length !== 1) return null;
  return usable(candidates[0]) ? candidates[0] : null;
}

export default function EnterToSave() {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== "Enter" || e.shiftKey || e.ctrlKey || e.altKey || e.metaKey || e.isComposing || e.defaultPrevented) return;
      const el = e.target;
      if (!el || el.tagName !== "INPUT") return;
      if (SKIP_TYPES.has((el.type || "").toLowerCase())) return;
      if (el.closest("form") || el.closest("[data-enter-ignore]") || el.hasAttribute("data-enter-ignore")) return;
      const btn = findTarget(el);
      if (!btn) return;
      e.preventDefault();
      // pastikan nilai input terakhir sudah ter-commit ke state sebelum klik
      setTimeout(() => btn.click(), 0);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);
  return null;
}
